import Form from 'react-bootstrap/Form';

function ConsumersAdvanceEligibilityForm({
  advanceEligibilityFilter,
  changeAdvanceEligibilityFilter,
  spinner,
}) {
  return (
    <Form.Select
      className="bo-filter bo-w-350"
      type="select"
      disabled={spinner}
      value={advanceEligibilityFilter}
      onChange={e => changeAdvanceEligibilityFilter('consumers', e.target.value)}
    >
      <option value="">All Advance Eligibility Statuses</option>
      <option value="ELIGIBLE">Eligible</option>
      <option value="NOT_ELIGIBLE_RISK_ASSESSMENT_REQUIRED">
        Not Eligible - Risk Assessment Required
      </option>
      <option value="NOT_ELIGIBLE_HIGH_RISK">Not Eligible - High Risk</option>
    </Form.Select>
  );
}

export default ConsumersAdvanceEligibilityForm;
